export default __webpack_public_path__ + "static/media/logo_generalitat.85dd3808.png";